import { Injectable } from "@angular/core";
import { HttpClient } from "../../shared/wrappers/HttpClient";
import { Parcel } from "../../models/billing-letter/Parcel.model";
import * as bluebird from 'bluebird';
import * as _ from 'lodash';

@Injectable()
export class BillingParcelService {
    constructor(private httpClient: HttpClient) { }

    endPoint: String = "/billing-parcels";

    async getByID(id) {
        return await this.httpClient.get(`${this.endPoint}/${id}`);
    }

    async updateOne(parcel: Parcel) {
        return await this.httpClient.update(`${this.endPoint}`, parcel._id, parcel);
    }

    async create(parcel: Parcel) {
        delete parcel._id
        return await this.httpClient.post(`${this.endPoint}`, parcel);
    }

    async createMultipleParcels(parcels: Parcel[]) {
        return bluebird.map(parcels, (parcel) => {
            return this.httpClient.post(this.endPoint,
            _.cloneDeep(parcel))
        }, { concurrency: 20 });
    }

    async delete(parcel: Parcel) {
        return await this.httpClient.delete(this.endPoint, parcel._id);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/billing-letter/billing-parcel.service.ts